
import React from "react";
import * as ReactRouterDom from "react-router-dom";
import { i18nManager } from "../../i18n";
import { pagePath } from "../../helpers";
import TeamTile from "../common/TeamTile";
import SectionHeader from "../common/SectionHeader";
import styles from "../../assets/style.module.css";
import { ITeamHistory } from "../../../../../services";

export interface TeamTilesProps {
    basePath: string;
    teamHistories: ITeamHistory[];
}

function TeamTiles({ basePath, teamHistories }: TeamTilesProps) {

    const labels = i18nManager.Labels.home;
    const [searchParams] = ReactRouterDom.useSearchParams(window.location.search);

    if (!teamHistories.length) return null;

    return (<section className={styles["bg-paper2"]}>
        <div className={styles["container"]} style={{ paddingTop: 80 }}>
            <SectionHeader kicker={labels.teams_kicker} title={labels.teams_title} titleEm={labels.teams_title_em}
                action={<ReactRouterDom.NavLink end className={styles["link-more"]} to={{ pathname: pagePath(basePath, "TEAM_HISTORY"), search: searchParams.toString() }}>{labels.view_teams}</ReactRouterDom.NavLink>} />
        </div>
        <div className={styles["tiles"]}>
            {teamHistories.slice(0, 4).map((t) => (<TeamTile key={t.external_id} team={t} />))}
        </div>
    </section>);
}

export default TeamTiles;
